import {KTIcon} from '../_metronic/helpers'

function DeleteLabel() {
  return (
    <div className="px-3 py-2 d-flex align-items-center">
      <KTIcon iconName="trash" className="text-danger fs-6 p-0" />
      <span className="ms-2">Delete</span>
    </div>
  )
}

export default DeleteLabel
